module.exports = __webpack_public_path__ + "img/gtzy1_zhTc.c20da89a.png";